// custom cart cyo 
// Function to disable CYO product links in both cart drawer and cart page
// Function to remove href attributes from CYO products
function removeCYOProductHrefs() {
  const cartItems = document.querySelectorAll('.hdt-mini-cart__item, .hdt-page-cart__infos-wrap');
  
  cartItems.forEach(item => {
    const titleLink = item.querySelector('.hdt-mini-cart__title, .hdt-page-cart__title');
    const imageLink = item.querySelector('.hdt-mini-cart__img, .hdt-page-cart__img');
    const hasBoxProperty = item.querySelector('.hdt-product-details__item-label .hdt-font-normal');
    
    if (titleLink) {
      const titleText = titleLink.textContent.trim();
      const isCYO = titleText.startsWith('CYO');
      const hasBox = hasBoxProperty && hasBoxProperty.textContent.trim() === 'Box:';
      
      if (isCYO || hasBox) {
        // Remove href attribute completely
        if (titleLink.hasAttribute('href')) {
          titleLink.removeAttribute('href');
          titleLink.style.cursor = 'default';
          titleLink.style.textDecoration = 'none';
          titleLink.style.pointerEvents = 'none';
        }
        
        if (imageLink && imageLink.hasAttribute('href')) {
          imageLink.removeAttribute('href');
          imageLink.style.cursor = 'default';
          imageLink.style.pointerEvents = 'none';
        }
      }
    }
  });
}

// Prevent clicks on CYO product links (backup protection)
document.addEventListener('click', function(e) {
  const titleLink = e.target.closest('.hdt-mini-cart__title, .hdt-page-cart__title');
  const imageLink = e.target.closest('.hdt-mini-cart__img, .hdt-page-cart__img');
  
  if (titleLink || imageLink) {
    const cartItem = e.target.closest('.hdt-mini-cart__item, .hdt-page-cart__infos-wrap');
    
    if (cartItem) {
      const title = cartItem.querySelector('.hdt-mini-cart__title, .hdt-page-cart__title');
      const hasBoxProperty = cartItem.querySelector('.hdt-product-details__item-label .hdt-font-normal');
      
      if (title) {
        const titleText = title.textContent.trim();
        const isCYO = titleText.startsWith('CYO');
        const hasBox = hasBoxProperty && hasBoxProperty.textContent.trim() === 'Box:';
        
        if (isCYO || hasBox) {
          e.preventDefault();
          e.stopPropagation();
          return false;
        }
      }
    }
  }
}, true);

// Run on page load
document.addEventListener('DOMContentLoaded', removeCYOProductHrefs);

// Run after a short delay to catch any dynamic content
document.addEventListener('DOMContentLoaded', function() {
  setTimeout(removeCYOProductHrefs, 100);
  setTimeout(removeCYOProductHrefs, 500);
});

// Also run when cart updates
document.addEventListener('cart:updated', removeCYOProductHrefs);

// MutationObserver for dynamic cart updates (drawer)
const cartDrawer = document.querySelector('#CartDrawer-Form, .hdt-mini-cart');
if (cartDrawer) {
  const drawerObserver = new MutationObserver(function() {
    removeCYOProductHrefs();
  });
  drawerObserver.observe(cartDrawer, { 
    childList: true, 
    subtree: true 
  });
}

// MutationObserver for cart page updates
const cartPage = document.querySelector('#CartPage-Form, .hdt-page-cart');
if (cartPage) {
  const pageObserver = new MutationObserver(function() {
    removeCYOProductHrefs();
  });
  pageObserver.observe(cartPage, { 
    childList: true, 
    subtree: true 
  });
}

// Watch for cart drawer opening
const observer = new MutationObserver(function(mutations) {
  mutations.forEach(function(mutation) {
    if (mutation.attributeName === 'class' || mutation.attributeName === 'style') {
      const drawer = document.querySelector('#CartDrawer-Form, .hdt-mini-cart');
      if (drawer && (drawer.classList.contains('active') || drawer.style.display !== 'none')) {
        setTimeout(removeCYOProductHrefs, 50);
      }
    }
  });
});

// Observe the cart drawer for visibility changes
const cartDrawerElement = document.querySelector('cart-drawer, #CartDrawer, .cart-drawer');
if (cartDrawerElement) {
  observer.observe(cartDrawerElement, { 
    attributes: true,
    attributeFilter: ['class', 'style']
  });
}
// custom cart cyo -end

//cyo bundle creator easify app js

(function () {
  const STEP = 10;
  const gridsState = new Map();

  function getProducts(gridWrapper) {
    return gridWrapper.querySelectorAll(".productContent-module__card_product__Hh");
  }

  function updateButtonVisibility(gridWrapper, state, btnWrapper) {
    const products = getProducts(gridWrapper);
    const btn = btnWrapper.querySelector('button');

    // If there are more products in the DOM than we are currently showing, keep button visible
    if (products.length > state.visibleItems) {
      btnWrapper.style.display = "block";
      if (btn) btn.textContent = "Load More Products";
    } else {
      // Otherwise hide it (MutationObserver will bring it back if the app adds more)
      btnWrapper.style.display = "none";
    }
  }

  function applyVisibility(gridWrapper, visibleItems) {
    const products = getProducts(gridWrapper);
    products.forEach((product, index) => {
      product.style.display = index < visibleItems ? "" : "none";
    });
  }

  function initGrid(gridWrapper) {
    if (!gridsState.has(gridWrapper)) {
      gridsState.set(gridWrapper, {
        visibleItems: STEP,
        buttonAdded: false,
        btnElement: null
      });
    }

    const state = gridsState.get(gridWrapper);
    const products = getProducts(gridWrapper);

    if (products.length === 0) return;

    applyVisibility(gridWrapper, state.visibleItems);

    // Create Button if it doesn't exist
    if (products.length > STEP && !state.buttonAdded) {
      const btnWrapper = document.createElement("div");
      btnWrapper.className = "cyo-load-more-wrapper";
      btnWrapper.style.cssText = "text-align:center; margin: 30px 0; width:100%; clear:both;";

      btnWrapper.innerHTML = `
        <button class="cyo-load-more-btn" style="cursor:pointer; padding: 12px 35px; background:#000; color:#fff; border:none; border-radius:4px; font-weight:bold; font-size:16px;">
          Load More Products
        </button>`;

      const btn = btnWrapper.querySelector('button');

      btn.addEventListener("click", (e) => {
        e.preventDefault();

        const countBefore = getProducts(gridWrapper).length;
        state.visibleItems += STEP;
        applyVisibility(gridWrapper, state.visibleItems);

        btn.textContent = "Loading...";

        window.dispatchEvent(new Event('scroll'));
        window.scrollBy(0, 1);

        // Wait to see if new products are injected into the DOM
        setTimeout(() => {
          const currentProducts = getProducts(gridWrapper);
          const countAfter = currentProducts.length;

          if (state.visibleItems >= countAfter && countAfter <= countBefore) {
            btnWrapper.style.display = "none";
          } else {
            btn.textContent = "Load More Products";
            applyVisibility(gridWrapper, state.visibleItems);
            updateButtonVisibility(gridWrapper, state, btnWrapper);
          }
        }, 1500);
      });

      gridWrapper.after(btnWrapper);
      state.buttonAdded = true;
      state.btnElement = btnWrapper;
    }

    // Always re-check visibility when the grid updates
    if (state.buttonAdded && state.btnElement) {
      updateButtonVisibility(gridWrapper, state, state.btnElement);
    }
  }

  // Monitor for any changes (like new products being added to the DOM)
  let debounceTimer;
  const observer = new MutationObserver(() => {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(() => {
      const gridWrappers = document.querySelectorAll(".cyo-product-grid-wapper");
      gridWrappers.forEach(grid => initGrid(grid));
    }, 200);
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  // Start initialization
  if (document.readyState === 'complete') {
    const gridWrappers = document.querySelectorAll(".cyo-product-grid-wapper");
    gridWrappers.forEach(grid => initGrid(grid));
  } else {
    window.addEventListener('load', () => {
      const gridWrappers = document.querySelectorAll(".cyo-product-grid-wapper");
      gridWrappers.forEach(grid => initGrid(grid));
    });
  }
})();


// add to box button trigger on paroduct card
document.addEventListener('click', function (e) {
  console.log('Click detected on:', e.target);

  const productCard = e.target.closest('.cyo-product-grid-wapper .productContent-module__card_product__Hh');

  if (productCard) {
   
    const isExcluded = e.target.closest('.cyo-product-grid-wapper .addToBoxButton-module__button_atc__zo') ||
      e.target.closest('.cyo-product-grid-wapper .productContent-module__icon_search_product__Lx') ||
      e.target.closest('.cyo-product-grid-wapper a') || 
      e.target.closest('.cyo-product-grid-wapper button');

    if (isExcluded) {
      return;
    }

    const addToBoxBtn = productCard.querySelector('.cyo-product-grid-wapper .addToBoxButton-module__button_atc_content__wU');

    if (addToBoxBtn) {
      const clickEvent = new MouseEvent('click', {
        view: window,
        bubbles: true,
        cancelable: true
      });

      addToBoxBtn.dispatchEvent(clickEvent);
      //console.log(' Add to Box button clicked with MouseEvent!');
    } else {
      //console.log('❌ Add to Box button NOT found');
    }
  } else {
    //console.log('ℹ️ Click outside product card');
  }
});
//cyo bundle creator easify app js - end

//title trimming
function getMaxLength() {
  return window.innerWidth < 768 ? 35 : 60;
}

function truncateTitles() {
  const maxLength = getMaxLength();

  document.querySelectorAll('.t4s-product-title a').forEach(title => {
    const text = title.getAttribute('data-original-text') || title.textContent.trim();

    if (!title.getAttribute('data-original-text')) {
      title.setAttribute('data-original-text', text);
    }

    if (text.length > maxLength) {
      title.textContent = text.substring(0, maxLength) + '...';
    } else {
      title.textContent = text; // Restore full text if it fits
    }
  });
}

// Run on page load
truncateTitles();

// Re-run every time a tab is clicked
document.querySelectorAll('.t4s-tab-item a').forEach(tab => {
  tab.addEventListener('click', () => {
    setTimeout(truncateTitles, 300);
  });
});

// Re-run on window resize to handle screen size changes
window.addEventListener('resize', truncateTitles);


// upsell slider dots to one line

(function() {
  function scrollActiveDot() {
    const container = document.querySelector('.flickityt4s-page-dots');
    if (!container) return;

    const slider = document.querySelector('.flickityt4s-slider');
    if (!slider) return;

    const slides = Array.from(slider.querySelectorAll('.t4s-col-item'));
    const selectedIndex = slides.findIndex(s => s.classList.contains('is-selected'));
    if (selectedIndex === -1) return;

    const dots = Array.from(container.querySelectorAll('.dot'));
    const targetDot = dots[selectedIndex];
    if (!targetDot) return;

    // Force scroll using scrollLeft directly
    const targetScroll = targetDot.offsetLeft - (container.offsetWidth / 2) + (targetDot.offsetWidth / 2);
    container.scrollLeft = targetScroll;
  }

  // Watch slider for slide changes
  const slider = document.querySelector('.flickityt4s-slider');
  if (slider) {
    new MutationObserver(scrollActiveDot).observe(slider, {
      subtree: true,
      attributes: true,
      attributeFilter: ['class']
    });
  }

  // Also watch dots directly
  const dots = document.querySelector('.flickityt4s-page-dots');
  if (dots) {
    new MutationObserver(scrollActiveDot).observe(dots, {
      subtree: true,
      attributes: true,
      attributeFilter: ['class']
    });
  }

  // Fallback: click listener on arrows
  document.addEventListener('click', function(e) {
    if (e.target.closest('.flickityt4s-prev-next-button') || e.target.closest('.dot')) {
      setTimeout(scrollActiveDot, 100);
      setTimeout(scrollActiveDot, 300);
    }
  });

  setTimeout(scrollActiveDot, 500);
})();